var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1F22",
    d: "M11.583.75H2.416A1.83 1.83 0 0 0 .592 2.583L.583 17.25 7 14.5l6.416 2.75V2.583A1.84 1.84 0 0 0 11.583.75m0 13.75L7 12.502 2.416 14.5V2.583h9.167z"
  })));
};
export default SvgFlag;